// src/components/CardSkeleton.jsx
export default function CardSkeleton() {
  return (
    <div className="edge-mobile">
      <div className="card square-mobile animate-pulse">
        <div className="space-y-3">
          <div className="h-4 w-2/3 rounded bg-gray-200/30 dark:bg-white/10" />
          <div className="h-3 w-1/3 rounded bg-gray-200/30 dark:bg-white/10" />
          <div className="h-3 w-1/2 rounded bg-gray-200/30 dark:bg-white/10" />
        </div>
      </div>
    </div>
  );
}
